import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { WEBSITE_GENERIC_LANGUAGES } from "@utils/localisation"

import Markdown from "@components/Markdown"
import MetaButton from "@components/MetaButton"
import ModuleHeader4 from "@components/ModuleHeader4"

import backgroundImage from "@images/stock-market-forex-trading-graph-graphic-concept.jpg"
import { LinkToEnter } from "../../components/PriceAlertsForm/LinkToEnter"

const ContentContainer = ({
  theme = "blue-bg",
  fn,
  dataEvent,
  inverted = true,
  language = "en",
  ...rest
}) => {
  const { t } = useTranslation()
  const headerText = t("banner_Header")
  const contentText = t("banner_Text")
  const buttonText = t("banner_Button")

  const getDestinationURL = _language => {
    const languageToUse = WEBSITE_GENERIC_LANGUAGES.includes(_language)
      ? _language
      : "en"
    return (languageToUse !== "en" ? `/${languageToUse}` : "") + "/price-alerts"
  }

  return (
    <div className={`flex flex-col justify-center mx-6 sm:mx-16 my-8 sm:my-8`}>
      <div>
        <ModuleHeader4
          theme={theme}
          className={"desk:text-[32px] font-medium md:text-[28px]"}
        >
          {headerText}
        </ModuleHeader4>
        <div
          className={`font-inter leading-150% text-sm desk:text-20 md:text-16 font-normal text-[#C0BFC4]`}
        >
          <Markdown>{contentText}</Markdown>
        </div>
        <LinkToEnter destinationURL={getDestinationURL(language)}>
          <MetaButton
            theme={theme}
            dataEvent={dataEvent}
            inverted={inverted}
            as="link"
            className="inline-flex"
            url={getDestinationURL(language)}
            {...rest}
          >
            {buttonText}
          </MetaButton>
        </LinkToEnter>
      </div>
    </div>
  )
}

export const PriceAlertsBanner = ({
  theme = "blue-bg",
  fn = null,
  dataEvent = "",
  language = "en",
  ...props
}) => {
  return (
    <div className={`bg-[#151124]`}>
      <div
        className={`w-full mx-auto flex flex-col 
			sm:flex-row
			h-full desk:min-h-[422px] md:min-h-[299px]
			bg-[#151124]
			bg-no-repeat
			sm:bg-contain
			
			bg-top
			
			sm:bg-[-160px]
			md:bg-[-100px]
			desk:bg-left
			bg-[length:100%_200px]
			 
			`}
        {...props}
        style={{
          backgroundImage: `url("${backgroundImage}")`,
        }}
      >
        <div
          className={`imageSpaceContainer grow 
			min-h-[200px]
			desk:min-w-[798px] h-full desk:min-h-[422px] 
			md:min-h-[299px]
			max-w-[50%] 
			min-w-[40%]
			`}
        ></div>
        <ContentContainer
          theme={theme}
          fn={fn}
          dataEvent={dataEvent}
          language={language}
        />
      </div>
    </div>
  )
}
